import DealerRequestListPanel from "./dealerRequestListPanel.container"

export default DealerRequestListPanel
